import styled from "styled-components";

export const Container = styled.div`
    all: unset;

    width: auto;
    height: auto;
    padding: 0.5rem 0.75rem;

    display: flex;
    align-items: center;

    cursor: ${(props => props.disabled ? 'not-allowed' : 'pointer')};

    /* width: 100px;
    height: auto;
    padding: 0.5rem 0.75rem;

    position: relative;
    left: ${props => props.responsive ? '8%' : '0%'};
    top: ${props => props.responsive ? '70px' : '0px'};

    margin: 0px;
    display: flex;
    cursor: ${(props => props.disabled ? 'not-allowed' : 'pointer')};

    @media only screen and (max-width: 991px) {
        left: ${props => props.isModal ? props.responsive ? '8%' : '4px' : props.responsive ? '0%' : '4px%'};
        top: ${props => props.isModal ? props.responsive ? '70px' : '0px' : props.responsive ? '0px' : '0px'};
    }

    @media only screen and (max-width: 540px){
        left: ${props => props.responsive ? '8%' : '4px'};
        top: ${props => props.responsive ? '70px' : '0px'};
    } */

    >span{
        text-align: center;
    }
`;
